






























































































































































































































































































































































import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import isEmail from 'validator/lib/isEmail';
import EventBus from '@/eventBus';

import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeading from '@/components/Atoms/co-heading/CoHeading.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoProgressBar from '@/components/Molecules/co-progress-bar/CoProgressBar.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoPlanSelectConfigCustomise from '@/components/Organisms/co-plan-select-config-customise-modal/CoPlanSelectConfigCustomiseModal.vue';
import CoCardPlan from '@/components/Molecules/co-card-plan/CoCardPlan.vue';

const MAX_ROWS = 100;
const CSV_TEMPLATE_FILENAME = 'bulk-member-create-template.csv';
const baseUrl = process.env.BASE_URL || '/';
const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
const CSV_TEMPLATE_URL = `${normalizedBaseUrl}static/${CSV_TEMPLATE_FILENAME}`;

const HEADER_MAP: Record<string, string> = {
    email: 'email',
    firstname: 'firstName',
    lastname: 'lastName',
    company: 'company',
    planid: 'planId',
    planname: 'planName',
    plan: 'plan',
    extrasids: 'extraIds',
    extrasid: 'extraIds',
    extrasnames: 'extraNames',
    extrasname: 'extraNames',
    extras: 'extras',
    suppresswelcomeemail: 'suppressWelcomeEmail',
    salutation: 'salutation',
};

export default {
    name: 'MemberBulkCreate',
    components: {
        CoCard,
        CoHeading,
        CoText,
        CoButton,
        CoInput,
        CoFormGroup,
        CoTable,
        CoAlert,
        CoSelect,
        CoCheckbox,
        CoRoundButton,
        CoProgressBar,
        CoModal,
        CoPlanSelectConfigCustomise,
        CoCardPlan,
    },
    data() {
        return {
            csvFileName: '',
            csvError: null,
            rows: [],
            loading: false,
            runLogs: [],
            runProgress: {
                current: 0,
                total: 0,
            },
            editingRow: {
                id: '',
                rowNumber: 0,
                email: '',
                firstName: '',
                lastName: '',
                company: '',
                planId: '',
                planName: '',
                extraIds: [],
                extraNames: [],
                planCleared: false,
                metadata: {},
                metadataInput: '',
                suppressWelcomeEmail: false,
                salutation: 'u',
            },
            editingRowPlan: null,
            editingRowPlanCleared: false,
            defaultSuppressWelcomeEmail: false,
            collectionMethod: null,
            defaultPlan: null,
            plans: [],
            extras: [],

            salutationOptions: [
                {
                    Value: 'x',
                    Name: this.$t('labels.nonbinary'),
                },
                { Value: 'f', Name: this.$t('labels.female') },
                { Value: 'm', Name: this.$t('labels.male') },
                { Value: 'u', Name: this.$t('labels.prefernottosay') },
            ],
        };
    },
    computed: {
        maxRows() {
            return MAX_ROWS;
        },
        showProgress() {
            return this.runProgress.total > 0;
        },
        readyToRun() {
            return this.rows.length > 0 && !this.loading;
        },
        showKeepOpenAlert() {
            return this.loading || this.rows.length > 0;
        },
        previewColumns() {
            return [
                { key: 'rowNumber', title: '#', notSortable: true, style: 'width: 60px' },
                { key: 'email', title: this.$t('labels.email'), notSortable: true },
                { key: 'firstName', title: this.$t('labels.namefirst'), notSortable: true },
                { key: 'lastName', title: this.$t('labels.namelast'), notSortable: true },
                { key: 'company', title: this.$t('labels.company'), notSortable: true },
                { key: 'planLabel', title: this.$t('labels.plan'), notSortable: true },
                { key: 'extrasLabel', title: this.$t('labels.upgrade'), notSortable: true },
                { key: 'action', title: '', notSortable: true, style: 'width: 60px' },
            ];
        },
        resultColumns() {
            return [
                { key: 'email', title: this.$t('labels.email'), notSortable: true },
                { key: 'message', title: this.$t('labels.status'), notSortable: true },
            ];
        },
        collectionMethodOptions() {
            return [
                { Name: this.$t('labels.chargeautomatically'), Value: 'CHARGE_AUTOMATICALLY' },
                { Name: this.$t('labels.sendinvoice'), Value: 'SEND_INVOICE' },
            ];
        },
    },
    created() {
        this.collectionMethod = this.collectionMethodOptions[1] || this.collectionMethodOptions[0] || null;
        this.loadPlans();
        this.loadExtras();
    },
    methods: {
        getNextRowNumber() {
            if (!this.rows.length) {
                return 1;
            }
            const maxRowNumber = Math.max(...this.rows.map((row) => row.rowNumber || 0));
            return maxRowNumber + 1;
        },
        createEmptyRow() {
            const rowNumber = this.getNextRowNumber();
            const defaultExtras = this.defaultPlan?.Extras || [];
            return {
                id: `manual-${rowNumber}-${Math.random().toString(36).slice(2, 8)}`,
                rowNumber,
                email: '',
                firstName: '',
                lastName: '',
                company: '',
                planId: this.defaultPlan?.ID || '',
                planName: this.defaultPlan?.Name || '',
                extraIds: defaultExtras.map((extra) => extra.ID),
                extraNames: defaultExtras.map((extra) => extra.Name),
                planCleared: false,
                fromCsv: false,
                metadata: {},
                suppressWelcomeEmail: this.defaultSuppressWelcomeEmail,
                salutation: '',
            };
        },
        addManualRow() {
            if (this.loading || this.rows.length >= MAX_ROWS) {
                return;
            }
            this.openRowEditor(this.createEmptyRow());
        },
        downloadCsvTemplate() {
            const link = document.createElement('a');
            link.href = CSV_TEMPLATE_URL;
            link.download = CSV_TEMPLATE_FILENAME;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        selectCollectionMethod(option) {
            this.collectionMethod = option?.Value || 'CHARGE_AUTOMATICALLY';
        },
        triggerCsvSelect() {
            if (this.loading) {
                return;
            }
            const input = this.$refs.csvInput;
            if (input) {
                input.click();
            }
        },
        handleCsvInputKeydown(event) {
            if (!event) return;
            const actionableKeys = ['Enter', ' '];
            if (actionableKeys.includes(event.key)) {
                event.preventDefault();
                this.triggerCsvSelect();
            }
        },
        onCsvSelected(event) {
            const file = event && event.target ? event.target.files[0] : null;
            this.rows = [];
            this.csvError = null;
            this.csvFileName = '';
            this.runLogs = [];
            this.resetProgress();
            if (!file) {
                if (event && event.target) {
                    event.target.value = '';
                }
                return;
            }
            const fileExtension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            if (file.type && !file.type.includes('csv') && file.type !== 'text/plain' && fileExtension !== 'csv') {
                this.csvError = 'Invalid file type. Please upload a CSV file.';
                if (event && event.target) {
                    event.target.value = '';
                }
                return;
            }
            this.csvFileName = file.name;
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e && e.target ? e.target.result : null;
                if (typeof text !== 'string') {
                    this.csvError = 'Could not read the CSV file.';
                    return;
                }
                this.handleCsvContent(text);
            };
            reader.onerror = () => {
                this.csvError = 'Could not read the CSV file.';
            };
            reader.readAsText(file);
            if (event && event.target) {
                event.target.value = '';
            }
        },
        handleCsvContent(content) {
            const lines = content.split(/\r?\n/).filter((line) => line.trim().length > 0);
            if (!lines.length) {
                this.csvError = 'CSV is empty.';
                return;
            }
            const headerRow = this.parseCsvLine(lines[0]);
            const headers = headerRow.map((header) => header.trim());
            const parsedRows = [];
            const startIndex = 1;
            for (let i = startIndex; i < lines.length; i += 1) {
                if (parsedRows.length >= MAX_ROWS) {
                    this.csvError = `Max ${MAX_ROWS} rows per run. Extra rows were ignored.`;
                    break;
                }
                const row = this.parseCsvLine(lines[i]);
                const rowData = this.buildRowFromCsv(headers, row, i + 1);
                if (rowData) {
                    parsedRows.push(rowData);
                }
            }
            if (!parsedRows.length) {
                this.csvError = 'No valid rows were found.';
                return;
            }
            this.rows = parsedRows.map((row) => this.decorateRow(row));
        },
        buildRowFromCsv(headers, values, rowNumber) {
            const row = {
                id: `${rowNumber}-${Math.random().toString(36).slice(2, 8)}`,
                rowNumber,
                email: '',
                firstName: '',
                lastName: '',
                company: '',
                planId: '',
                planName: '',
                extraIds: [],
                extraNames: [],
                planCleared: false,
                fromCsv: true,
                metadata: {},
                suppressWelcomeEmail: false,
                salutation: '',
            };

            headers.forEach((header, index) => {
                const rawValue = values[index] != null ? values[index].trim() : '';
                if (!rawValue) {
                    return;
                }
                const normalizedHeader = this.normalizeHeader(header);
                const mappedKey = HEADER_MAP[normalizedHeader];
                if (!mappedKey) {
                    row.metadata[header] = rawValue;
                    return;
                }
                switch (mappedKey) {
                    case 'email':
                        row.email = rawValue;
                        break;
                    case 'firstName':
                        row.firstName = rawValue;
                        break;
                    case 'lastName':
                        row.lastName = rawValue;
                        break;
                    case 'company':
                        row.company = rawValue;
                        break;
                    case 'planId':
                        row.planId = rawValue;
                        break;
                    case 'planName':
                        row.planName = rawValue;
                        break;
                    case 'plan':
                        if (this.findPlanById(rawValue)) {
                            row.planId = rawValue;
                        } else {
                            row.planName = rawValue;
                        }
                        break;
                    case 'extraIds':
                        row.extraIds = this.parseList(rawValue);
                        break;
                    case 'extraNames':
                        row.extraNames = this.parseList(rawValue);
                        break;
                    case 'extras':
                        this.parseList(rawValue).forEach((item) => {
                            if (this.findExtraById(item)) {
                                row.extraIds.push(item);
                            } else {
                                row.extraNames.push(item);
                            }
                        });
                        break;
                    case 'suppressWelcomeEmail':
                        row.suppressWelcomeEmail = this.parseBoolean(rawValue);
                        break;
                    case 'salutation':
                        row.salutation = rawValue;
                        break;
                    default:
                        row.metadata[header] = rawValue;
                        break;
                }
            });

            return row;
        },
        decorateRow(row) {
            const resolvedPlan = this.resolveRowPlan(row);
            const planLabel = resolvedPlan?.Name || '';
            const resolvedExtras = this.resolveRowExtras(row, resolvedPlan);
            const extrasLabel = resolvedExtras.length > 0 ? resolvedExtras.map((extra) => extra.Name).join(', ') : '';
            const metadataSummary = Object.keys(row.metadata || {}).length
                ? Object.keys(row.metadata)
                      .slice(0, 3)
                      .map((key) => `${key}`)
                      .join(', ')
                : '';
            return {
                ...row,
                planLabel,
                extrasLabel,
                metadataSummary,
            };
        },
        normalizeHeader(header) {
            return header.toLowerCase().replace(/[\s_-]+/g, '');
        },
        parseCsvLine(line) {
            const result = [];
            let current = '';
            let inQuotes = false;
            for (let i = 0; i < line.length; i += 1) {
                const char = line[i];
                if (char === '"') {
                    if (inQuotes && line[i + 1] === '"') {
                        current += '"';
                        i += 1;
                    } else {
                        inQuotes = !inQuotes;
                    }
                } else if (char === ',' && !inQuotes) {
                    result.push(current);
                    current = '';
                } else {
                    current += char;
                }
            }
            result.push(current);
            return result.map((item) => item.trim());
        },
        parseList(value) {
            return value
                .split(/[,;|]/)
                .map((item) => item.trim())
                .filter((item) => item.length > 0);
        },
        parseMetadata(value) {
            if (!value) {
                return {};
            }
            try {
                const parsed = JSON.parse(value);
                if (parsed && typeof parsed === 'object') {
                    return parsed;
                }
            } catch (error) {
                // fallback to key=value pairs
            }
            const entries = {};
            value.split(/[;|]/).forEach((pair) => {
                const [key, ...rest] = pair.split('=');
                if (key && rest.length) {
                    entries[key.trim()] = rest.join('=').trim();
                }
            });
            if (Object.keys(entries).length) {
                return entries;
            }
            return { value };
        },
        parseBoolean(value) {
            const normalized = String(value).trim().toLowerCase();
            return ['true', '1', 'yes', 'y'].includes(normalized);
        },
        handleRowClick(index, item) {
            if (item) {
                this.openRowEditor(item);
            }
        },
        openRowEditor(row) {
            const metadataInput = row.metadata && Object.keys(row.metadata).length ? JSON.stringify(row.metadata) : '';
            const resolvedPlan = this.resolveRowPlan(row);
            const resolvedExtras = this.resolveRowExtras(row, resolvedPlan);
            this.editingRow = {
                ...cloneDeep(row),
                metadataInput,
            };
            this.editingRowPlanCleared = false;
            this.editingRowPlan = resolvedPlan
                ? {
                      ...cloneDeep(resolvedPlan),
                      Extras: resolvedExtras,
                  }
                : null;
            this.$refs.editRowModal?.show();
        },
        selectRowSalutation(option) {
            if (this.editingRow) {
                this.editingRow.salutation = option?.Value || '';
            }
        },
        showRowPlanModal() {
            this.$refs.selectRowPlanModal?.show();
        },
        chooseRowPlan(plan) {
            this.editingRowPlan = plan || null;
            this.editingRowPlanCleared = false;
            this.$refs.selectRowPlanModal?.hide();
        },
        clearRowPlan() {
            this.editingRowPlan = null;
            this.editingRowPlanCleared = true;
        },
        cancelRowEdit() {
            this.$refs.editRowModal?.hide();
            this.editingRow = null;
            this.editingRowPlan = null;
            this.editingRowPlanCleared = false;
        },
        saveRowEdit() {
            if (!this.editingRow) {
                return;
            }
            const updated = {
                ...this.editingRow,
                metadata: this.parseMetadata(this.editingRow.metadataInput || ''),
            };
            delete updated.metadataInput;
            if (this.editingRowPlan) {
                updated.planId = this.editingRowPlan.ID;
                updated.planName = this.editingRowPlan.Name;
                updated.planCleared = false;
                const selectedExtras = this.editingRowPlan.Extras || [];
                updated.extraIds = selectedExtras.map((extra) => extra.ID);
                updated.extraNames = selectedExtras.map((extra) => extra.Name);
            } else if (this.editingRowPlanCleared) {
                updated.planId = '';
                updated.planName = '';
                updated.extraIds = [];
                updated.extraNames = [];
                updated.planCleared = true;
            }
            const existingIndex = this.rows.findIndex((row) => row.id === updated.id);
            if (existingIndex >= 0) {
                this.rows = this.rows.map((row) => (row.id === updated.id ? this.decorateRow(updated) : row));
            } else {
                this.rows = [...this.rows, this.decorateRow(updated)];
            }
            this.$refs.editRowModal?.hide();
            this.editingRow = null;
            this.editingRowPlan = null;
            this.editingRowPlanCleared = false;
        },
        showDefaultPlanModal() {
            this.$refs.selectDefaultPlanModal?.show();
        },
        chooseDefaultPlan(plan) {
            this.defaultPlan = plan || null;
            this.$refs.selectDefaultPlanModal?.hide();
            this.rows = this.rows.map((row) => this.decorateRow(row));
        },
        clearDefaultPlan() {
            this.defaultPlan = null;
            this.rows = this.rows.map((row) => this.decorateRow(row));
        },
        clearCsv() {
            this.rows = [];
            this.csvError = null;
            this.csvFileName = '';
            this.runLogs = [];
            this.resetProgress();
            if (this.$refs.csvInput) {
                this.$refs.csvInput.value = '';
            }
        },
        resetProgress() {
            this.runProgress.current = 0;
            this.runProgress.total = 0;
        },
        findPlanById(id) {
            return this.plans.find((plan) => String(plan.ID).toLowerCase() === String(id).toLowerCase());
        },
        findPlanByName(name) {
            return this.plans.find((plan) => String(plan.Name).toLowerCase() === String(name).toLowerCase());
        },
        findExtraById(id) {
            return this.extras.find((extra) => String(extra.ID).toLowerCase() === String(id).toLowerCase());
        },
        findExtraByName(name) {
            return this.extras.find((extra) => String(extra.Name).toLowerCase() === String(name).toLowerCase());
        },
        buildMembershipPayload(plan, extras, userID) {
            const normalizedPlan = cloneDeep(plan);
            normalizedPlan.Extras = extras;
            if (normalizedPlan.TaxRate) {
                normalizedPlan.TaxRateID = normalizedPlan.TaxRate.ID || normalizedPlan.TaxRate.Value?.ID;
                delete normalizedPlan.TaxRate;
            }
            if (normalizedPlan.Extras && normalizedPlan.Extras.length) {
                normalizedPlan.Extras.forEach((extra) => {
                    if (extra.TaxRate) {
                        extra.TaxRateID = extra.TaxRate.ID || extra.TaxRate.Value?.ID;
                        delete extra.TaxRate;
                    }
                });
            }
            return {
                plan: {
                    plan: normalizedPlan,
                    userID,
                },
                childPlans: [],
                start: 0,
                end: 0,
                anchorDate: 0,
                freeTrialDays: 0,
                collectionMethod: this.collectionMethod?.Value || this.collectionMethod,
                prorate: false,
                prorationDate: 0,
            };
        },
        resolvePlan(row) {
            const candidates = [];
            if (row.planId) candidates.push(row.planId);
            if (row.planName) candidates.push(row.planName);
            for (let i = 0; i < candidates.length; i += 1) {
                const value = candidates[i];
                const byId = this.findPlanById(value);
                if (byId) return byId;
            }
            for (let i = 0; i < candidates.length; i += 1) {
                const value = candidates[i];
                const byName = this.findPlanByName(value);
                if (byName) return byName;
            }
            return null;
        },
        resolveExtras(row) {
            const extras = [];
            const seen = new Set();
            const candidates = [...(row.extraIds || []), ...(row.extraNames || [])];
            candidates.forEach((value) => {
                const byId = this.findExtraById(value);
                const byName = this.findExtraByName(value);
                const extra = byId || byName;
                if (extra && !seen.has(extra.ID)) {
                    seen.add(extra.ID);
                    extras.push(extra);
                }
            });
            return extras;
        },
        getDefaultPlanForRow(row) {
            if (row.planId || row.planName || row.planCleared) {
                return null;
            }
            return this.defaultPlan;
        },
        resolveRowPlan(row) {
            if (row.planId || row.planName) {
                const resolved = this.resolvePlan(row);
                if (resolved) {
                    return resolved;
                }
                if (row.fromCsv && !row.planCleared) {
                    return this.defaultPlan;
                }
                return null;
            }
            if (row.planCleared) {
                return null;
            }
            return this.defaultPlan;
        },
        resolveRowExtras(row, fallbackPlan) {
            const hasRowExtras = (row.extraIds || []).length || (row.extraNames || []).length;
            const resolvedRowExtras = hasRowExtras ? this.resolveExtras(row) : [];
            if (hasRowExtras && resolvedRowExtras.length > 0) {
                return resolvedRowExtras;
            }
            if (row.planCleared) {
                return [];
            }
            const fallbackUsedForPlan =
                row.fromCsv &&
                !row.planCleared &&
                (row.planId || row.planName) &&
                !this.resolvePlan(row) &&
                fallbackPlan;
            if (hasRowExtras && !fallbackUsedForPlan) {
                return resolvedRowExtras;
            }
            if (fallbackPlan && Array.isArray(fallbackPlan.Extras) && fallbackPlan.Extras.length) {
                return fallbackPlan.Extras;
            }
            return [];
        },
        buildUserPayload(row) {
            const metadata = cloneDeep(row.metadata || {});
            const shouldSuppress = row.suppressWelcomeEmail || this.defaultSuppressWelcomeEmail;
            if (shouldSuppress) {
                metadata.suppress_welcome_email = true;
            }
            const payload: any = {
                FirstName: row.firstName,
                LastName: row.lastName,
                Email: row.email,
                Salutation: row.salutation || '',
            };
            if (Object.keys(metadata).length) {
                payload.Metadata = metadata;
            }
            return payload;
        },
        async runBulkCreate() {
            if (this.loading) {
                return;
            }
            if (this.rows.length > MAX_ROWS) {
                this.csvError = `Max ${MAX_ROWS} rows per run.`;
                return;
            }
            this.loading = true;
            this.runLogs = [];
            this.runProgress.total = this.rows.length;
            this.runProgress.current = 0;

            for (let i = 0; i < this.rows.length; i += 1) {
                const row = this.rows[i];
                const logEntry = await this.processRow(row);
                this.runLogs = [...this.runLogs, logEntry];
                this.runProgress.current = i + 1;
            }

            const hasFailures = this.runLogs.some((log) => log.status === 'failed');
            EventBus.$emit(hasFailures ? 'ERROR' : 'INFO', {
                Message: hasFailures ? 'Bulk create finished with errors.' : 'Bulk create finished successfully.',
                Details: '',
            });
            this.loading = false;
        },
        async processRow(row) {
            const email = row.email || '(missing email)';
            if (!row.email || !isEmail(row.email)) {
                return { email, status: 'failed', message: 'Invalid or missing email.' };
            }
            if (!row.firstName || !row.lastName) {
                return { email, status: 'failed', message: 'Missing first or last name.' };
            }
            const plan = this.resolveRowPlan(row);
            const hasPlanInput = Boolean(row.planId || row.planName);
            if (!plan && hasPlanInput) {
                return {
                    email,
                    status: 'failed',
                    message: 'Plan not found. Check Plan ID or Plan Name, or set a default plan.',
                };
            }

            const extras = plan ? this.resolveRowExtras(row, plan) : [];
            let userID = null;
            try {
                const userPayload = this.buildUserPayload(row);
                const response = await axios({
                    method: 'POST',
                    url: `/admin/community/member`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: JSON.stringify(userPayload),
                });
                userID = response?.data?.ID;
            } catch (error) {
                const message =
                    error?.response?.data?.message ||
                    error?.response?.data ||
                    error?.message ||
                    'Failed to create user.';
                return { email, status: 'failed', message };
            }

            if (!userID) {
                return { email, status: 'failed', message: 'User created, but ID was missing.' };
            }

            if (!plan) {
                return { email, status: 'success', message: 'User created (no plan provided).' };
            }

            try {
                const membershipPayload = this.buildMembershipPayload(plan, extras, userID);
                await axios({
                    method: 'POST',
                    url: `/admin/community/member/membership/${userID}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: JSON.stringify(membershipPayload),
                });
            } catch (error) {
                const message =
                    error?.response?.data?.message ||
                    error?.response?.data ||
                    error?.message ||
                    'User created, but membership failed.';
                return { email, status: 'failed', message };
            }

            return { email, status: 'success', message: 'User and membership created.' };
        },
        async loadPlans() {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `/admin/plan/list`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const plans = response?.data?.Plans || [];
                this.plans = plans.filter((plan) => plan.Active);
            } catch (error) {
                EventBus.$emit('ERROR', {
                    Message: 'Failed to load plans. Using mock plans.',
                    Details: '',
                });
            }
        },
        async loadExtras() {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `/admin/extra/list`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const extras = response?.data?.Extras || [];
                this.extras = extras;
            } catch (error) {
                EventBus.$emit('ERROR', {
                    Message: 'Failed to load extras. Using mock extras.',
                    Details: '',
                });
            }
        },
    },
};
